<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" html='contact_info_and_mailing_address.page_title'></h1>

    <form>
         <h3 html='contact_info_and_mailing_address.whatIsPostal'></h3>
         <div id="postalCode" html='contact_info_and_mailing_address.forEmample'></div>
         
         <ng-input [(ng-model)]="postalCode" id="postalCodeInput"
                   [(ng-error)]="error_postalCode"       
                   (keydown)="onPostalCodeChange()"             
                   size="7" max="7" 
                   [ng-disable]="contact.address.chk_international=='Y' || notEditable"
                   alt-text="contact_info_and_mailing_address.postalCode_alt">{{'contact_info_and_mailing_address.postalCode'}}</ng-input>
      
         <ng-checkbox [(ng-model)]="contact.address.chk_international" 
                      [ng-disable]="notEditable" (change)="chkIntChanged()">
                      {{'contact_info_and_mailing_address.isInternational'}}</ng-checkbox>
    
         <h3 translate [hidden]="contact.address.chk_international=='Y'" class="padding-top-1em">
               {{'contact_info_and_mailing_address.selectToVerifyPostalCode'}}</h3>
         
         <div [hidden]="contact.address.chk_international=='Y'">
             <div class="btn-mobile">
                 <button class="btn-check" (click)="verifyPostalCode()" [attr.disabled]="notEditable" 
                  alt-text="contact_info_and_mailing_address.verifyPostalCode_alt"
                 translate>{{'contact_info_and_mailing_address.verifyPostalCode'}}</button>
             </div>
         </div>
         
      <light-box input-class="white-box">
            <ng-radio [(ng-model)]="selectedRange"   #list
                        input-class="light-box" 
                        [item-list]="rangeList"
                        [(ng-error)]="error_selectRange" vertical>
                        <h2 html="contact_info_and_mailing_address.confirmAddressRange"></h2>
                        <div html='contact_info_and_mailing_address.selectRangeDesc'></div>
            </ng-radio>
            <button class="btn-check" style="margin:0.3em 0 1.2em 2em"
                   (click)="onMyClose()" title="{{'contact_info_and_mailing_address.continue_alt' | translate}}" translate>
                  {{'contact_info_and_mailing_address.continue'}}
            </button>
      </light-box>
         
      <div class="postalcode-verify" [hidden]="isPostalCodeValid!='Y' || contact.address.chk_international=='Y'" [innerHTML]="'contact_info_and_mailing_address.postalCodeVerified'|translate : postalCodeParam"></div>
      <errors [hidden]="isPostalCodeValid!='N' || contact.address.chk_international=='Y'" [error]="'contact_info_and_mailing_address.postalCodeError'|translate : postalCodeParam"></errors>
    
      <div [hidden]="contact.address.chk_international=='Y'">

                  <hr class="padding-top-hr">
                  <h2 html='contact_info_and_mailing_address.contactInfo' class="padding-top-1em"></h2>
                  <div html='contact_info_and_mailing_address.whatsPhoneNumber'></div>
                  <fieldset> 
                  <legend>
                       <div id="phoneNumber" html='contact_info_and_mailing_address.telephoneNumber' class="phone-margin"></div>
                  </legend>
           
                  <div class="phone-div">
                        <div class="phone-label-area" translate>{{'contact_info_and_mailing_address.areaCode'}}</div>
                        <div class="phone-label-local">
                              <span translate style="margin-right:0.4em">{{'contact_info_and_mailing_address.local'}}</span>
                              <span translate>{{'contact_info_and_mailing_address.number'}}</span>
                        </div>      
                        <div class="phone-label-ext" style="vertical-align: middle;" translate>{{'contact_info_and_mailing_address.extension'}}</div>
                  </div>


                        <ng-input space="0.8" type="tel" id="areaCode" outer-class="control-margin0"
                              [(ng-model)]="contact.phoneArea" 
                              [(ng-clear)]="error_phoneNumber" 
                              [ng-disable]="notEditable"
                              alt-text="contact_info_and_mailing_address.areaCode_alt"
                              size="3" max="3">
                              <span translate='contact_info_and_mailing_address.areaCode' class="sr-only"></span>
                        </ng-input>
                        
                        <ng-input space="0.3" type="tel" id="localNumber_1" outer-class="control-margin0"
                              [(ng-model)]="contact.phoneNumber1" 
                              [ng-disable]="notEditable"
                              size="3" max="3" label-style="text-align:center" 
                              [(ng-clear)]="error_phoneNumber" 
                              alt-text="contact_info_and_mailing_address.localNumber_alt1">
                              <span translate='contact_info_and_mailing_address.local' class="sr-only"></span>
                              <span translate='contact_info_and_mailing_address.number' class="sr-only"></span>
                        </ng-input>
                        
                        <span style="padding-right:0.3em">-</span>
                        <ng-input space="0.8" type="tel" id="localNumber_2"  outer-class="control-margin0"
                              [(ng-model)]="contact.phoneNumber2" 
                              [ng-disable]="notEditable"
                              size="4" max="4" label-style="margin-left:0" 
                              [(ng-clear)]="error_phoneNumber" 
                              alt-text="contact_info_and_mailing_address.localNumber_alt2">
                              <span translate='contact_info_and_mailing_address.local' class="sr-only"></span>
                              <span translate='contact_info_and_mailing_address.number' class="sr-only"></span>
                        </ng-input>
                        
                        <ng-input space="0" type="tel"        outer-class="control-margin0"
                              [(ng-model)]="contact.phoneExt" 
                              [(ng-clear)]="error_phoneNumber"
                              [ng-disable]="notEditable"
                              size="4" max="6"
                              alt-text="contact_info_and_mailing_address.extension_alt">
                              <span translate='contact_info_and_mailing_address.extension' class="sr-only"></span>
                        </ng-input>
                       
                        <errors [error]="error_phoneNumber"></errors>   
                  
            </fieldset>

            <fieldset>
                  <legend>
                       <div translate='contact_info_and_mailing_address.daytimePhoneNumber' class="phone-margin-day"></div>
                  </legend>

                  <div class="phone-div">
                        <div class="phone-label-area" translate>{{'contact_info_and_mailing_address.areaCode'}}</div>
                        <div class="phone-label-local">
                              <span translate style="margin-right:0.4em">{{'contact_info_and_mailing_address.local'}}</span>
                              <span translate>{{'contact_info_and_mailing_address.number'}}</span>
                        </div>      
                        <div class="phone-label-ext" style="vertical-align: middle;" translate>{{'contact_info_and_mailing_address.extension'}}</div>
                  </div>

                  

                        <ng-input space="0.8" type="tel" id="daytimePhoneArea" outer-class="control-margin0"
                              [(ng-model)]="contact.daytimePhoneArea"  
                              [(ng-clear)]="error_daytimePhoneNumber"                        
                              [ng-disable]="notEditable"
                              size="3" max="3" 
                              alt-text="contact_info_and_mailing_address.daytimeAreaCode_alt">
                        <span translate='contact_info_and_mailing_address.areaCode' class="sr-only"></span>
                        </ng-input>
                  
                        <ng-input space="0.3" type="tel"    outer-class="control-margin0"
                              [(ng-model)]="contact.daytimePhoneNumber1" 
                              [(ng-clear)]="error_daytimePhoneNumber" 
                              [ng-disable]="notEditable"
                              size="3" max="3" label-style="text-align:center" 
                              alt-text="contact_info_and_mailing_address.daytimeLocalNumber_alt1">
                              <span translate='contact_info_and_mailing_address.local' class="sr-only"></span>
                              <span translate='contact_info_and_mailing_address.number' class="sr-only"></span>
                        </ng-input>
                        
                        <span style="padding-right:0.3em">-</span>

                        <ng-input space="0.8" type="tel"   outer-class="control-margin0"
                              [(ng-model)]="contact.daytimePhoneNumber2" 
                              [(ng-clear)]="error_daytimePhoneNumber" 
                              [ng-disable]="notEditable"
                              size="4" max="4" label-style="margin-left:0" 
                              alt-text="contact_info_and_mailing_address.daytimeLocalNumber_alt2">
                              <span translate='contact_info_and_mailing_address.local' class="sr-only"></span>
                              <span translate='contact_info_and_mailing_address.number' class="sr-only"></span>
                        </ng-input>
                  
                        <ng-input space="0" type="tel"  outer-class="control-margin0"
                              [(ng-model)]="contact.daytimeExt" 
                              [(ng-clear)]="error_daytimePhoneNumber" 
                              [ng-disable]="notEditable"
                              size="4" max="6" 
                              alt-text="contact_info_and_mailing_address.daytimeExtension_alt">
                              <span translate='contact_info_and_mailing_address.extension' class="sr-only"></span>
                        </ng-input>

                        <errors [error]="error_daytimePhoneNumber"></errors>
                  
            </fieldset>

            <hr class="mp-top-hr">
            <h2 html='contact_info_and_mailing_address.mailingAddress' class="padding-top-1em"></h2>
            <div html='contact_info_and_mailing_address.verifyAndEnterBelow'></div>
            <canada-address #canadaAddr [address]="contact.address"></canada-address>                  

       </div>
    
       <div [hidden]="contact.address.chk_international!='Y'">             
                  <hr class="padding-top-hr">
                  <h2 html='contact_info_and_mailing_address.contactInfo' class="padding-top-1em"></h2>
                  <div html='contact_info_and_mailing_address.whatsPhoneNumber'></div>
                  <fieldset>
                  <legend>
                  <div id="intPhoneNumber" html='contact_info_and_mailing_address.telephoneNumber' class="phone-margin"></div>
                  </legend>
                  <div class="phone-div">
                        <span style="margin-right:0.3em">+</span>
                        <ng-input width="28%"  type="tel" id="countryCode"
                              [(ng-model)]="contact.phoneArea" 
                              [(ng-clear)]="error_intPhoneNumber" 
                              [ng-disable]="notEditable"          size="3" max="5" 
                              label='contact_info_and_mailing_address.countryCode'
                              alt-text="contact_info_and_mailing_address.countryCode_alt">
                        </ng-input>
                        
                        <ng-input width="31%" type="tel" 
                              [(ng-model)]="contact.phoneNumber1"  size="3" max="5" 
                              [(ng-clear)]="error_intPhoneNumber" 
                              [ng-disable]="notEditable"
                              label='contact_info_and_mailing_address.areaCityCode'
                              alt-text="contact_info_and_mailing_address.areaCityCode_alt">
                        </ng-input>
                        
                        <ng-input width="34%" type="tel" 
                              [(ng-model)]="contact.phoneNumber2"  size="6" max="10" 
                              [(ng-clear)]="error_intPhoneNumber" 
                              [ng-disable]="notEditable"
                              label='contact_info_and_mailing_address.localNumber2'
                              alt-text="contact_info_and_mailing_address.localNumber_alt">
                        </ng-input>
                        
                        <errors [error]="error_intPhoneNumber"></errors>     
                  </div>     
            </fieldset>
            <fieldset>
                  <legend>
                  <div html='contact_info_and_mailing_address.daytimePhoneNumber' class="phone-margin"></div>
                  </legend>
                  <div class="phone-div">
                        <span style="margin-right:0.3em">+</span>
                        <ng-input width="28%" type="tel" 
                              [(ng-model)]="contact.daytimePhoneArea" 
                              [(ng-clear)]="error_intDaytimePhoneNumber" 
                              [ng-disable]="notEditable"            size="3" max="5" 
                              label='contact_info_and_mailing_address.countryCode'
                              alt-text="contact_info_and_mailing_address.daytimeCountryCode_alt">
                              </ng-input>
                  
                        <ng-input width="30%"  type="tel" 
                              [(ng-model)]="contact.daytimePhoneNumber1"      size="3" max="5" 
                              [(ng-clear)]="error_intDaytimePhoneNumber" 
                              [ng-disable]="notEditable"
                              label='contact_info_and_mailing_address.areaCityCode'
                              alt-text="contact_info_and_mailing_address.daytimeAreaCityCode_alt">
                        </ng-input>
                        
                        <ng-input width="35%"  type="tel" 
                              [(ng-model)]="contact.daytimePhoneNumber2"      size="6" max="10" 
                              [(ng-clear)]="error_intDaytimePhoneNumber" 
                              [ng-disable]="notEditable"
                              label='contact_info_and_mailing_address.localNumber2'
                              alt-text="contact_info_and_mailing_address.daytimeLocalNumber_alt">
                        </ng-input>
                        
                        <errors [error]="error_intDaytimePhoneNumber"></errors>
                  </div>
            </fieldset>
                  <hr>
                  <h2 html='contact_info_and_mailing_address.mailingAddress' class="padding-top-1em"></h2>
                  <div html='contact_info_and_mailing_address.verifyAndEnterBelow'></div>
                  <international-address #internAddr [address]="contact.address"></international-address>
            </div>
         
            <hr>
         
         <div id="sameAddress" [hidden]="data.eligibility.isBornThroughSurrogacy!='N'">
               <ng-radio [(ng-model)]="contact.isParentSameAddr" id="sameAddressRadio"
                      [item-list]="items.yesNoList"    margin="1/"
                      [(ng-error)]="error_sameAddress" 
                      [ng-disable]="notEditable"
                      (change)="resetPermanentAddress()" 
                      [label-param]="parentNameParam">
                      <div translate="contact_info_and_mailing_address.isMailingAddrSameAsParentAddr" [translateParams]="parentNameParam"></div>
                </ng-radio>
          
                <div id="addressType" [hidden]="contact.isParentSameAddr!='N'">          
                      <ng-radio [(ng-model)]="isCanadianAddress" id="isCanadianAddressRadio"
                            [item-list]="items.addressList"    margin="1/"
                            [(ng-error)]="error_selectAddrType" 
                            [ng-disable]="notEditable"
                            (change)="addressTypeChanged()" 
                            [label-param]="parentNameParam" vertical>
                            <h3 translate="contact_info_and_mailing_address.isParentAddrCanadian" [translateParams]="parentNameParam"></h3>
                      </ng-radio>
                      
                      <div [hidden]="motherContact.address.chk_international=='Y' || motherContact.address.chk_international==''">
                           <h2 id="motherCanadianAddr" translate="contact_info_and_mailing_address.permanentAddress" [translateParams]="parentNameParam"></h2>
                           <canada-address  #parentCanadaAddr [address]="motherContact.address"></canada-address>
                      </div>
                      <div [hidden]="motherContact.address.chk_international!='Y'">
                           <h2 id="motherIntAddr" translate="contact_info_and_mailing_address.permanentAddress" [translateParams]="parentNameParam"></h2>
                           <international-address #parentInternAddr [address]="motherContact.address"></international-address>      
                      </div>
               </div>
           </div>
    </form>
     <div class="btn-div">
          <div><button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
     </div>

</div>
